export * from './universities.model';
export * from './universities.module';
export * from './universities.seed';
export * from './universities.types';
